module.exports = __webpack_public_path__ + "img/instagram__green.d9b6aac0.svg";